import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/bannerInfo',
    name: 'BannerInfo',
    component: () => import('@/views/BannerInfo') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台'
    }
  },
  {
    path: '/productID',
    name: 'ProductID',
    component: () => import('@/views/ProductID') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
      keepAlive: true ,// 需要被缓存
    }
  },
  {
    path: '/brakeOil',
    name: 'BrakeOil',
    component: () => import('@/views/BrakeOil') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/modCaliper',
    name: 'ModCaliper',
    component: () => import('@/views/ModCaliper') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/frameCode',
    name: 'FrameCode',
    component: () => import('@/views/FrameCode') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,
  {
    path: '/carType',
    name: 'CarType',
    component: () => import('@/views/CarType') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
      keepAlive: true ,// 需要被缓存
      ifDoFresh: false , //需要刷新
    }
  } ,
  {
    path: '/goodDetail',
    name: 'GoodDetail',
    component: () => import('@/views/GoodDetail') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,
  {
    path: '/shopCar',
    name: 'ShopCar',
    component: () => import('@/views/ShopCar') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,
  {
    path: '/splitOrder',
    name: 'SplitOrder',
    component: () => import('@/views/SplitOrder') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,
  {
    path: '/orderSettle',
    name: 'OrderSettle',
    component: () => import('@/views/OrderSettle') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,
  {
    path: '/orderPay',
    name: 'OrderPay',
    component: () => import('@/views/OrderPay') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/preorderPay',
    name: 'preorderPay',
    component: () => import('@/views/PreorderPay') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },

  {
    path: '/orderSubmit',
    name: 'OrderSubmit',
    component: () => import('@/views/payStatus/OrderSubmit') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,
  {
    path: '/orderSubmitPayfail',
    name: 'OrderSubmitPayfail',
    component: () => import('@/views/payStatus/OrderSubmitPayfail') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/orderSubmitBank',
    name: 'PreorderSubmit',
    component: () => import('@/views/payStatus/orderSubmitBank') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/preorderSubmit',
    name: 'preorderSubmit',
    component: () => import('@/views/payStatus/preorderSubmit') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/orderperSubmit',
    name: 'OrderpreSubmit',
    component: () => import('@/views/payStatus/OrderpreSubmit') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  } ,

  //个人中心
  { path: '/user/',
    component: () => import('@/views/user/User') ,
    redirect: '/user/personal',
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    },
    children: [
      {
        // 当 /user/:id/profile 匹配成功，
        // UserProfile 会被渲染在 User 的 <router-view> 中
        path: 'personal',
        component:  () => import('@/components/component/User/userComponent/Personal') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      }, {
        path: 'monthDetail',
        component:  () => import('@/components/component/User/userComponent/MonthDetail') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'safeSetting',
        component:  () => import('@/components/component/User/userComponent/SafeSetting') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台'  ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'addressManage',
        component:  () => import('@/components/component/User/userComponent/AddressManage') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'order',
        component:  () => import('@/components/component/User/userComponent/Order') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'orderDetail',
        name: 'OrderDetail' ,
        component:  () => import('@/components/component/User/userComponent/OrderDetail') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },  //
      {
        path: 'orderDetailUnpay',
        name: 'OrderDetailUnpay' ,
        component:  () => import('@/components/component/User/userComponent/OrderDetailUnpay') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'orderDetailUnreceive',
        name: 'OrderDetailUnreceive' ,
        component:  () => import('@/components/component/User/userComponent/OrderDetailUnreceive') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'coupon',
        component:  () => import('@/components/component/User/userComponent/Coupon') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },

      {
        path: 'aftersale',
        component:  () => import('@/components/component/User/userComponent/Aftersale') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'applyAftersale',
        name: 'ApplyAftersale' ,
        component:  () => import('@/components/component/User/userComponent/ApplyAftersale') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      },
      {
        path: 'aftersaleDetail',
        name: 'AftersaleDetail' ,
        component:  () => import('@/components/component/User/userComponent/AftersaleDetail') ,
        meta: {
          title: 'DIXCEL ONLINE经销商采购平台' ,
          requireAuth: true,  // 该路由项需要权限校验
        }
      }
    ]
  },
  {
    path: '/conponCenter',
    name: 'ConponCenter',
    component: () => import('@/views/ConponCenter') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台' ,
      requireAuth: true,  // 该路由项需要权限校验
    }
  },
  {
    path: '/resetPassword',
    component: () => import('@/views/ResetPassword') ,
    meta: {
      title: 'DIXCEL ONLINE经销商采购平台'
    }
  }
]

const router = new VueRouter({
  routes ,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }
    return {x: 0, y: 0}
  }
})


router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title
  }

  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (localStorage.token) {  // 获取当前的token是否存在
      // console.log("token存在");
      next();
    } else {
      // console.log("token不存在");
      next({
        path: '/login', // 将跳转的路由path作为参数，登录成功后跳转到该路由
        query: {redirect: to.fullPath}
      })
    }
  }else { // 如果不需要权限校验，直接进入路由界面
    next();
  }
})


router.afterEach( () => {

} )

export default router
